import { render, staticRenderFns } from "./companyPartialLeavesComponent.vue?vue&type=template&id=691df25d&"
import script from "./companyPartialLeavesComponent.vue?vue&type=script&lang=js&"
export * from "./companyPartialLeavesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports